/**
 * Canonical app logger for the Vite client.
 *
 * - log / warn / info: dev or VITE_DEBUG only (no prod noise).
 * - error: always console.error; in production also forwards to telemetry.
 *
 * Edge (Deno) functions use supabase/functions/.../log.ts helpers; do not import this module there.
 */
import { captureError } from './telemetry'

const isDev = import.meta.env.DEV;
const isDebug = import.meta.env.VITE_DEBUG === 'true';

export const logger = {
  log: (...args: any[]) => {
    if (isDev || isDebug) {
      console.log(...args);
    }
  },

  warn: (...args: any[]) => {
    if (isDev || isDebug) {
      console.warn(...args);
    }
  },

  error: (...args: any[]) => {
    // Always log errors, but in production send to monitoring
    console.error(...args);

    if (!isDev) {
      captureError(new Error(String(args[0])), { extra: { args: args.slice(1) } })
    }
  },

  debug: (...args: any[]) => {
    if (isDebug) {
      console.debug(...args);
    }
  },

  info: (...args: any[]) => {
    if (isDev || isDebug) {
      console.info(...args);
    }
  }
};

// Make Sentry available globally for type checking
declare global {
  interface Window {
    Sentry?: {
      captureException: (error: Error, context?: any) => void;
    };
  }
}
